import { render, staticRenderFns } from "./RoleDetail.vue?vue&type=template&id=10fb9110&scoped=true"
import script from "./RoleDetail.vue?vue&type=script&lang=js"
export * from "./RoleDetail.vue?vue&type=script&lang=js"
import style0 from "./RoleDetail.vue?vue&type=style&index=0&id=10fb9110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb9110",
  null
  
)

export default component.exports